import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { subscribeUser } from "../../actions/susbcription";
import Message from "../../components/message";
import { Spinner } from "react-bootstrap";

import "./styles.css";
const Subscribe = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState();
  const [showMessage, setShowMessage] = useState("");
  const [messageVariant, setMessageVariant] = useState("");

  const subscribedUser = useSelector((state) => state.subscribedUser);
  const { loading, error, message } = subscribedUser;

  const handleSubcription = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      setShowMessage("Please enter an email address.");
      setMessageVariant("danger");
      return;
    }

    if (!emailPattern.test(email)) {
      setShowMessage("Please enter a valid email address.");
      setMessageVariant("danger");
      return;
    }

    dispatch(subscribeUser(email));
  };

  useEffect(() => {
    if (message && message.message) {
      setEmail("");
      setShowMessage(`${message.email} has bee subscribed successfully`);
      setMessageVariant("success");
    }
    setTimeout(() => {
      setShowMessage("");
    }, [3000]);
  }, [message]);

  useEffect(() => {
    if (error) {
      setShowMessage(error);
      setMessageVariant("danger");
    }
    setTimeout(() => {
      setShowMessage("");
    }, [5000]);
  }, [error]);

  return (
    <div>
      <div className="subscribe">
        <h2 className="subscribe__title">Let's keep in touch</h2>
        <p className="subscribe__copy">
          Subscribe to keep up with fresh news and exciting updates. We promise
          not to spam you!
        </p>

        {/* Input & Button in one div */}
        <div
          className="input-button-wrapper"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            width: "80%",
          }}
        >
          <input
            type="email"
            className="form__email"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              width: "100%",
            }}
          />
          <button
            className="form__button"
            onClick={handleSubcription}
            disabled={!email || loading}
            style={{
              minHeight: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "black",
              color: "white",
              border: "1px solid black",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#514f4f";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "black";
              e.target.style.color = "white";
            }}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                Subscribing...
              </>
            ) : (
              "Send"
            )}
          </button>
        </div>

        <div
          className="error-message"
          style={{
            minHeight: "20px",
            display: "flex",
            justifyContent: "flex-start",
            width: "80%",
          }}
        >
          {showMessage && (
            <small
              style={{
                color: messageVariant === "success" ? "green" : "#dc3545",
                marginTop: "5px",
                fontSize: "15px",
              }}
            >
              {showMessage}
            </small>
          )}
        </div>
      </div>
    </div>
  );
};

export default Subscribe;
